//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import { MP } from '@/utils/map'
import { fetchAttendance } from '@/api/staff'
import { removeToken, getToken } from '@/utils/storage'
import { toLogin } from '@/utils/toLogin'
import WorkStatus from './WorkStatus'
import store from '@/store'
import { employeeWorkStatus } from '@/api/systemManagement/workStatus'

export default {
  name: 'navBar',
  components: {
    WorkStatus
  },
  data () {
    return {
      isLoginOut: false,
      acttenance: {
        longitude: '',
        latitude: '',
        addr: '',
        type: 1,
        operate: 1
      },
      acttenanceFlag: false,
      showflag: true,
      windowWidth: document.body.clientWidth,
      workStatus: {},
      notReadMailNumber: 0
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'systemConfig_info',
      'systemConfig_name',
      'systemConfig_title',
      'systemConfig_logo',
      'systemConfig_IM',
      'systemConfig_asset'
    ])
  },
  mounted () {
    // this.getLocation()
    var _this = this
    window.onclick = function () {
      _this.isLoginOut = false
    }
    window.addEventListener('message', function (messageEvent) {
      var data = messageEvent.data
      if (data === 'close') {
        _this.isLoginOut = false
      }
    }, false)
  },
  created () {
    this.getWorkStatus()
  },
  methods: {
    toDownloadPage () {
      window.open('http://uworker.unicloud.com/#/download')
    },
    toMail () {
      // window.open('http://uworker.unicloud.com/web-oa/page/html/ssologin.html')
      window.open('https://mail.xcuni.com:8443/mail')
    },
    getWorkStatus () {
      employeeWorkStatus({
        ids: [this.userInfo.employeeNo]
      }).then(res => {
        if (res.data.code === '200') {
          this.workStatus = res.data.data[0]
        }
      })
    },
    handelActtenance () {
      var datas = this.acttenance
      if (this.acttenanceFlag === false) {
        this.acttenanceFlag = true
        setTimeout(this.clearAcctenanceFlag, 1100)
        fetchAttendance(datas).then(response => {
          if (response.data.code === '200') {
            this.$message({
              type: 'success',
              message: '签到成功'
            })
            window.frames[0].postMessage('acttence', '*')
          }
        })
      }
    },
    clearAcctenanceFlag () {
      this.acttenanceFlag = false
    },
    getLocation () {
      this.acttenance.operate = this.userInfo.checkNum % 2 === 0 ? 1 : 2
      let that = this
      MP('7F2tzD5GiZ5Q3O0bFiGgwGGG').then(BMap => {
        var geolocation = new BMap.Geolocation()
        var gc = new BMap.Geocoder()
        var pt
        geolocation.getCurrentPosition(function (r) { // 定位经纬度
          if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            that.acttenance.longitude = r.point.lng
            that.acttenance.latitude = r.point.lat

            pt = new BMap.Point(r.point.lng, r.point.lat)
            gc.getLocation(pt, function (rs) { // 解析经纬度到地址
              that.acttenance.addr = rs.addressComponents.province + rs.addressComponents.city + rs.addressComponents.district +
                rs.addressComponents.street + rs.addressComponents.streetNumber
            })
          }
        })
      })
    },
    loginOut () {
      store.dispatch('LogOut').then(() => {
        // router.push('/login')
        toLogin()
      })
    },
    editWorkStatus () {
      this.$refs.workStatus.open(this.workStatus)
    },
    modifyPassword () {
      this.$router.push('/changeLoginPassword')
    },
    handelStartIM () {
      window.location.href = `uWorker:\\token:${getToken()}`
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/layout/components/Navbar.vue